var _rect, _path, _path2, _rect2, _rect3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBosCourseProposal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b3",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#43e97b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#38f9d7"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 14,
    fill: "#f1f5f9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14h22l8 8v30a4 4 0 0 1-4 4H18a4 4 0 0 1-4-4V18a4 4 0 0 1 4-4z",
    fill: "url(#b3)",
    opacity: 0.92
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 14v8h8",
    fill: "#fff",
    opacity: 0.22
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 30,
    width: 18,
    height: 3,
    rx: 1,
    fill: "#fff",
    opacity: 0.55
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 38,
    width: 14,
    height: 3,
    rx: 1,
    fill: "#fff",
    opacity: 0.45
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 46h14",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBosCourseProposal);
export default __webpack_public_path__ + "static/media/bos-course-proposal.386a158225a616cde218911f7cd12bf7.svg";
export { ForwardRef as ReactComponent };